/**
 * @desc: 涉控黄名单
 * @created: 2020/5/22
 * @author: Colorfule
 * @version: v1.0
 */

import request from '@/plugins/http'
import qs from 'qs';

// 条件查询数据列表
export const getListData = params => {
  return request.get('/risk/yellow/list', params)
}

// 释放黄/黑名单的商户/供应商
export const riskFreedRelease = data => {
  return request.post('/risk/black/release', qs.stringify(data))
}
